import React from 'react';
import {
  OutlinedTextFields,
  CommonDropdownOutlined,
  ModalFactory,
  IFSCFinder,
  IFSCSearchButton,
  CheckboxField
} from '@Components';
import { r_maxLength } from '../../../utils/validation/restrictions';
import { BE_BASE_URL } from '../../../utils/config';
import { Field } from 'redux-form';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
import orderBy from 'lodash/orderBy';
import flatten from 'lodash/flatten';
import uniq from 'lodash/uniq';
import get from 'lodash/get';
import { BENEFICIARY_FULL_NAME_WARNING_MESSAGE, BENE_FIELDS } from '../constant';
import styled from 'styled-components';
import './style.css';
import { INDIVIDUAL } from '../../../utils/constants';
import { CLOSE_HEAVY_ICON, FILLED_CHECKBOX_ICON } from '@Images';
import { dynamic_validator2, fullNameValidation, required } from '@Utils/validation';
import { BeneIdentityHelperText } from '../../beneficiary-flow/pages/personal-details/styles';
import {
  BENE_ADDRESS_HELPER_TEXT,
  BENE_NAME_HELPER_TEXT,
  BENE_NAME_INCOMPLETE_HELPER_TEXT
} from '../../beneficiary-flow/pages/personal-details/utils/constants';
import { FieldContainerBankFields } from '../../beneficiary-flow/pages/bank-details/styles';

const FieldWrapper = styled.div`
  width: ${(props) => props.width};
`;

const CheckboxFieldContainer = styled.div`
  margin-top: 16px !important;
`;

const validatorCache = new Map();

export const getOrCreateValidator = (fieldValidation) => {
  const key = JSON.stringify(fieldValidation);

  if (!validatorCache.has(key)) {
    const validator = (value, allValues, props, name) => {
      let errors;
      errors = dynamic_validator2(value, fieldValidation, errors, {
        isCorp: false,
        allValues,
        name
      });
      return errors;
    };
    validatorCache.set(key, validator);
  }

  return validatorCache.get(key);
};

export const renderFunc = (field, props, fieldWidth, formErrors, forMeta) => {
  let {
    formValues,
    conditional_validation,
    onCountryOfResidenceChange,
    selfPopulatingData,
    isAddressRequired,
    handleEdit,
    handleInitFieldsForIN,
    setBeneCountryFieldDisabled,
    setBeneIdTypeFieldDisabled,
    applyInFieldValidation = false,
    isSingleRowField = false,
    isBeneAdditionFlow = false,
    formName
  } = props;

  const enumData =
    formValues?.bene_schema_validation?.proxy_type?.enum?.map((item, index) => ({
      key: index,
      value: item,
      text: item
    })) || [];

  const selectedProxyTpe = enumData?.find((item) => item?.text === formValues?.proxy_type);

  const checkForBrazil =
    formValues?.bank_account_country === 'BR' &&
    formValues?.payout_method === 'PROXY' &&
    conditional_validation &&
    typeof selectedProxyTpe === 'object' &&
    selectedProxyTpe !== null;

  const checkForIndia =
    formValues?.bank_account_country === 'IN' &&
    formValues?.currency_code === 'INR' &&
    formValues?.account_type === INDIVIDUAL;

  if (field) {
    if (
      field.render &&
      (field.render.visibility === 'VISIBLE' || field.render.visibility === 'CONDITIONAL')
    ) {
      const renderObj = field.render;
      const validationObj = field.validation;
      const apiConfig = field.api;
      const onChangeConfig = field.on_change;
      const staticValues = map(field.enum, (item, index) => ({
        key: index,
        value: item,
        text: item
      }));
      const apiUrl = !isEmpty(apiConfig)
        ? `${BE_BASE_URL}${apiConfig['version']}${apiConfig['url']}`
        : '';
      const dropdownStaticOptions = !isEmpty(apiUrl)
        ? null
        : !isEmpty(staticValues)
        ? staticValues
        : get(props, `renderStaticValueJSON.${renderObj['value_field_name']}`, null);
      const conditionalValidationApplicableKeys = get(
        conditional_validation,
        'data.conditionalValidationKeys',
        []
      );

      const isConditionalValidationApplicable = conditionalValidationApplicableKeys.includes(
        renderObj['value_field_name']
      );
      const isFieldCountryofResidence = renderObj.value_field_name === 'beneficiary_country_code';
      const isRemitterBeneFiciaryRelationship =
        renderObj.value_field_name === 'remitter_beneficiary_relationship';
      let key = `${formValues?.details_selected || field.sequence}_${
        renderObj['value_field_name']
      }`;
      if (!isEmpty(dropdownStaticOptions)) {
        key = `${key}_static_${dropdownStaticOptions.length}`;
      }
      let isFieldDisabled =
        renderObj.disabled ||
        (props.isPartiallyEditable &&
          !(renderObj['value_field_name'] === 'beneficiary_country_code')) ||
        (checkForIndia &&
          renderObj['value_field_name'] === 'last_name' &&
          formValues['is_legal_last_name_provided']) ||
        false;
      const beneResidenceFieldDisabled =
        renderObj['value_field_name'] === 'beneficiary_country_code' &&
        (field.const || props.isCountryOfResidenceDisabled);
      const beneIdTypeFieldDisabled =
        renderObj['value_field_name'] === 'beneficiary_identification_type' && field.const;
      if (beneResidenceFieldDisabled) setBeneCountryFieldDisabled(true);
      if (beneIdTypeFieldDisabled) setBeneIdTypeFieldDisabled(true);
      let isNameUnderTwoChars =
        checkForIndia &&
        renderObj['displayWarning'] &&
        formValues[renderObj['value_field_name']]?.length === 1;
      if (renderObj['value_field_name'] === 'last_name')
        isNameUnderTwoChars = isNameUnderTwoChars && !formValues['is_legal_last_name_provided'];

      const showIFSCSearchModal = async () => {
        await ModalFactory.builder(
          (onClose) => (
            <div className="logo-modal ifsc-modal">
              <img
                src={CLOSE_HEAVY_ICON}
                alt="close"
                className="close ifsc-close"
                onClick={() => onClose(false)}
              />
              <IFSCFinder
                formName={formName}
                isBeneSchema={true}
                closeModal={onClose}
                isNewFlow={true}
              />
            </div>
          ),
          'insta-modal center-modal',
          true
        );
      };
      const handleTextFieldChange = () => {
        if (checkForBrazil) {
          conditional_validation['handler'](renderObj['value_field_name'], selectedProxyTpe);
        }
      };
      const handleCheckBoxChange = () => {
        props.lastNameRecordHandler?.(formValues['last_name']);
        let lastNameRecorded = props.lastRecordedName;
        if (!formValues['is_legal_last_name_provided']) lastNameRecorded = null;
        else lastNameRecorded = props.lastRecordedName;
        props.dispatchAction(
          props.changeAction(
            'payeeDetails',
            'is_legal_last_name_provided',
            !formValues['is_legal_last_name_provided']
          )
        );

        props.dispatchAction(props.changeAction('payeeDetails', 'last_name', lastNameRecorded));
      };

      switch (renderObj.field) {
        case 'text': {
          const hasError =
            formErrors?.[renderObj['value_field_name']] &&
            forMeta?.[renderObj['value_field_name']]?.touched;
          return (
            <FieldContainerBankFields $isSingleRowField={isSingleRowField} key={key}>
              <FieldWrapper
                width={renderObj.label === 'IFSC' && !isSingleRowField ? '325px' : 'auto'}
              >
                <Field
                  name={renderObj['value_field_name']}
                  bindToThisObject={formValues[renderObj['value_field_name']]}
                  type="text"
                  component={OutlinedTextFields}
                  maxWidth={isSingleRowField ? '100%' : ''}
                  normalize={(() => {
                    if (validationObj) {
                      let { max_length } = validationObj;
                      if (max_length) {
                        return r_maxLength(max_length);
                      }
                    }
                    return;
                  })()}
                  validate={
                    applyInFieldValidation
                      ? formValues?.account_type === INDIVIDUAL &&
                        renderObj['value_field_name'] === 'beneficiary_name'
                        ? [fullNameValidation, getOrCreateValidator(field.validation)]
                        : [getOrCreateValidator(field.validation)]
                      : validationObj?.required
                      ? [required]
                      : []
                  }
                  onChange={handleTextFieldChange}
                  showSuccessIcon={formValues[renderObj['value_field_name'] + '_success']}
                  disabled={
                    isFieldDisabled || formValues[renderObj['value_field_name'] + '_disabled']
                  }
                  showEditIcon={
                    !isFieldDisabled && formValues[renderObj['value_field_name'] + '_disabled']
                  }
                  onEditBtnClick={() =>
                    handleEdit(
                      renderObj['value_field_name'] + '_disabled',
                      renderObj['value_field_name']
                    )
                  }
                  placeholder={renderObj.label}
                  // isEditable={isEditable}
                  tooltip={renderObj.tooltip}
                  boxSize={fieldWidth}
                  key={key}
                  id={key}
                  note={renderObj?.note}
                  destination_currency={formValues?.currency_code}
                  informationText={
                    isNameUnderTwoChars
                      ? BENEFICIARY_FULL_NAME_WARNING_MESSAGE.nameUnderTwoChars(
                          renderObj['label'] || 'name'
                        )
                      : null
                  }
                />
                {renderObj['value_field_name'] === 'beneficiary_name' && isBeneAdditionFlow && (
                  <BeneIdentityHelperText $marginTop={hasError ? '30px' : '6px'}>
                    {(() => {
                      const beneName = (formValues?.beneficiary_name || '').trim();
                      return beneName.length > 2 && /^\S+$/.test(beneName)
                        ? BENE_NAME_INCOMPLETE_HELPER_TEXT
                        : BENE_NAME_HELPER_TEXT;
                    })()}
                  </BeneIdentityHelperText>
                )}
                {renderObj.label === 'IFSC' && (
                  <IFSCSearchButton
                    className="IFSC_text"
                    type="button"
                    onClick={showIFSCSearchModal}
                  >
                    Search for IFSC
                  </IFSCSearchButton>
                )}
                {checkForIndia && renderObj['value_field_name'] === 'last_name' ? (
                  <CheckboxFieldContainer>
                    <Field
                      name="is_legal_last_name_provided"
                      checked={formValues['is_legal_last_name_provided']}
                      bindToThisObject={formValues['is_legal_last_name_provided']}
                      component={CheckboxField}
                      checkboxTextFontSize="12"
                      checkboxTextLineHeight="16"
                      broderBorder={true}
                      customImage={FILLED_CHECKBOX_ICON}
                      width={24}
                      height={24}
                      handleChange={handleCheckBoxChange}
                      checkboxContent={<>My recipient doesn’t have a last name</>}
                    />
                  </CheckboxFieldContainer>
                ) : null}
              </FieldWrapper>
            </FieldContainerBankFields>
          );
        }
        case 'dropdown': {
          return (
            <FieldContainerBankFields $isSingleRowField={isSingleRowField} key={key}>
              <Field
                bindToThisObject={formValues[renderObj['value_field_name']]}
                type="text"
                name={renderObj['value_field_name']}
                component={CommonDropdownOutlined}
                maxWidth={isSingleRowField ? '100%' : ''}
                placeholder={renderObj.label}
                className={`theme-dropdown`}
                staticValues={dropdownStaticOptions}
                disabled={isFieldDisabled || beneResidenceFieldDisabled}
                url={apiUrl}
                onDropdownChange={(data) => {
                  if (
                    isFieldCountryofResidence &&
                    onCountryOfResidenceChange &&
                    isAddressRequired
                  ) {
                    onCountryOfResidenceChange(data);
                  }
                  if (isConditionalValidationApplicable && conditional_validation) {
                    conditional_validation['handler'](renderObj['value_field_name'], data);
                  }
                  if (isRemitterBeneFiciaryRelationship && selfPopulatingData) {
                    selfPopulatingData(data);
                  }
                  checkForIndia &&
                    handleInitFieldsForIN &&
                    handleInitFieldsForIN(checkForIndia && data.text === 'Self');
                }}
                width={isSingleRowField ? '100%' : fieldWidth}
                key={key}
                id={key}
                // TODO: Check if its failing for other flows
                validate={
                  applyInFieldValidation
                    ? [getOrCreateValidator(field.validation)]
                    : validationObj?.required
                    ? [required]
                    : []
                }
              />

              {renderObj['value_field_name'] === 'beneficiary_country_code' &&
                isBeneAdditionFlow && (
                  <BeneIdentityHelperText>{BENE_ADDRESS_HELPER_TEXT}</BeneIdentityHelperText>
                )}
            </FieldContainerBankFields>
          );
        }
        case 'search_list': {
          return (
            <FieldContainerBankFields $isSingleRowField={isSingleRowField} key={key}>
              <Field
                bindToThisObject={formValues[renderObj['value_field_name']]}
                name={renderObj['value_field_name']}
                type="text"
                placeholder={renderObj.label}
                screen={formValues.screen}
                component={CommonDropdownOutlined}
                maxWidth={isSingleRowField ? '100%' : ''}
                bank_account_country={formValues.bank_account_country}
                onDropdownChange={(data) =>
                  props.searchListPopulateFieldHandler(data, onChangeConfig)
                }
                url={apiUrl}
                formName={formValues.formName || formName}
                fieldName={renderObj['value_field_name']}
                key={key}
                id={key}
                disabled={isFieldDisabled}
                appendValue={onChangeConfig && onChangeConfig[0]?.node}
                width="100%"
                validate={
                  applyInFieldValidation
                    ? [getOrCreateValidator(field.validation)]
                    : validationObj?.required
                    ? [required]
                    : []
                }
              />
            </FieldContainerBankFields>
          );
        }
        default:
          return null;
      }
    }
    return null;
  }
};

export const sortFields = (json) => {
  const arr = Object.keys(json).map((el) => {
    return json[el];
  });
  return orderBy(arr, 'render.sequence', ['ASC']);
};

export const dispatchConstFields = ({
  data,
  dispatch,
  change,
  formName,
  editMode = false,
  onCountryOfResidenceChangeHandler = null, // Make optional with default
  isAddressRequired = false
}) => {
  const constFields = [];
  const enumFields = [];
  ['personal_details', 'payout_details'].forEach((key) => {
    Object.values(data[key]).forEach((item) => {
      if (!isEmpty(item.const)) {
        constFields.push(item);
      } else if (!isEmpty(item.enum) && item.enum.length === 1) {
        enumFields.push(item);
      }
    });
  });
  if (!editMode) {
    constFields.forEach((item) => {
      if (
        item['render']['value_field_name'] === 'beneficiary_country_code' &&
        onCountryOfResidenceChangeHandler &&
        isAddressRequired
      ) {
        onCountryOfResidenceChangeHandler({ value: item.const });
      }

      dispatch(change(formName, item['render']['value_field_name'], item.const));
    });
    enumFields.forEach((item) => {
      dispatch(change(formName, item['render']['value_field_name'], item.enum[0]));
    });
  }
};

export const refactorConditionalField = (conditionValidation) => {
  if (isEmpty(conditionValidation)) {
    return {};
  }
  const conditionalValidationKeys = [];
  const conditionalValidationRefactored = flatten(conditionValidation['all_of']).map((item) => {
    const controllingField = get(item, 'if.properties', {});
    const dependentField = get(item, 'then.properties', {});
    conditionalValidationKeys.push(Object.keys(controllingField));
    return {
      controllingField,
      dependentField
    };
  });
  return {
    conditionalValidationKeys: uniq(flatten(conditionalValidationKeys)),
    validation: conditionalValidationRefactored
  };
};

export const resetAllFields = ({ dispatch, change, formName }) => {
  const fields = flatten(Object.values(BENE_FIELDS));
  fields.forEach((field) => {
    dispatch(change(formName, field, ''));
  });
};

export const allNewFields = () => {
  const fields = flatten(Object.values(BENE_FIELDS));
  let fieldsJson = {};
  fields.forEach((field) => {
    fieldsJson[field] = '';
  });
  return fieldsJson;
};
